module.exports = __webpack_public_path__ + "img/T621.970aad94.jpg";